<template>
  <div class="List" ref='wrapper'>
    <div>
      <div class="area">
        <div class="title border-topbotton">当前城市</div>
        <div class="button-list">
          <div class="button-wrapper">
            <div class="button">{{this.currentCity}}</div>
          </div>
        </div>
      </div>
     <div class="area">
        <div class="title border-topbotton">热门城市</div>
        <div class="button-list">
          <div class="button-wrapper"
            v-for='item of hot'
            :key='item.id'
            @click='HandelCityClick(item.name)'
          >
            <div class="button">{{item.name}}</div>
          </div>
        </div>
      </div>
      <div class="area"
        v-for='(item, key) of cities'
        :key='key'
        :ref='key'
      >
        <div class="title border-topbotton">{{key}}</div>
        <div class="item-list">
          <div class="item"
            v-for='innerItem of item'
            :key='innerItem.id'
            @click='HandelCityClick(innerItem.name)'
          >
            {{innerItem.name}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import BScroll from 'better-scroll'
export default {
  name: 'CityList',
  props: {
    hot: Array,
    cities: Object,
    letter: String
  },
  computed: {
    ...mapState({
      currentCity: 'city'
    })
  },
  methods: {
    HandelCityClick (city) {
      this.changeCity(city)
      this.$router.push('/')
    },
    ...mapMutations(['changeCity'])
  },
  watch: {
    letter () {
      if (this.letter) {
        const element = this.$refs[this.letter][0]
        this.scroll.scrollToElement(element)
      }
    }
  },
  mounted () {
    this.scroll = new BScroll(this.$refs.wrapper, {mouseWheel: true, click: true, tap: true})
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.List{
  overflow: hidden;
  position: absolute;
  top: 1.58rem;
  right: 0;
  bottom: 0;
  left: 0;
}
  .title{
    line-height: .54rem;
    background: #eee;
    padding-left: .2rem;
    color: #666;
    font-size: .26rem;
  }
    .button-list{
      overflow: hidden;
      padding: .1rem .6rem .1rem .1rem;
    }
      .button-wrapper{
        float: left;
        width: 33.33%;
      }
        .button{
          margin: .1rem;
          padding: .1rem 0;
          text-align: center;
          border: .02rem solid #ccc;
          border-radius: .06rem;
        }
  .item-list .item{
    line-height: .58rem;
    padding-left: .2rem;
    border-bottom: .001rem solid #ccc;
  }
</style>



// WEBPACK FOOTER //
// src/pages/city/components/List.vue